import { Image, Product, UseRowsReturn } from '@nettbureau/featured-core';
import { ProductCard } from '../card/ProductCard';
import { Featured } from '../featured/Featured';

interface ProductsSectionProps {
  products: UseRowsReturn<Product>;
  containerTitle: string;
  defaultBackground: Image | null;
}

export function ProductsSection({
  products,
  containerTitle,
  defaultBackground,
}: ProductsSectionProps) {
  return (
    <Featured<Product>
      rows={products}
      title={containerTitle}
      contactUrl={null}
      cardRenderer={(attributes, index) => {
        return (
          <ProductCard
            key={index}
            subscriptionLevel="premium"
            title={attributes.name}
            subTitle=""
            bodyLine1={attributes.description}
            bodyLine2={attributes.details}
            tags={attributes.tags}
            background={attributes.background ?? defaultBackground}
            logo={attributes.logo}
            internalLink={attributes.internalLink}
            icon={null}
            center={null}
          />
        );
      }}
    />
  );
}
